// src/utils/sausageNotBaconSkuOverrides.js
// London Smoke & Cure — fixed taxonomy: some retail names include "bacon" but the SKU is sausage.

/** @type {readonly string[]} */
export const SAUSAGE_NOT_BACON_OVERRIDE_SKUS = Object.freeze([
    'FS-MBSA-0700-PCE', // Maple & Bacon Sausages | Retail Pack (live SKU)
    'FS-MSBA-0700-PCE', // legacy typo alias — keep for older stamps
]);

const SKU_SET = new Set(SAUSAGE_NOT_BACON_OVERRIDE_SKUS.map((s) => s.toUpperCase()));

export function isSausageNotBaconOverrideSku(sku) {
    return SKU_SET.has(String(sku || '').trim().toUpperCase());
}

/**
 * When set, unifiedProductService.getProductCategory should return this instead of Firestore.
 * Use wording that downstream `.includes('sausage')` checks recognise.
 * @param {string} sku
 * @returns {string|null}
 */
export function getOverriddenProductCategoryIfAny(sku) {
    if (!isSausageNotBaconOverrideSku(sku)) return null;
    return 'Fresh Sausage';
}
